export const latestStableVersionName = "LATEST";
